import { useState } from "react";
import { useOutletContext } from "react-router-dom";
// import { toast } from "react-toastify";
import AddTableModal from "../../components/modals/AddTableModal";
import Stopwatch from "../../components/pool/Stopwatch";
// import { addTable, fetchTables } from "../../services/Tables";
import { Table } from "../../utilities/types";
import { isAdmin } from "../../utilities/common";
import { User } from "../management/ManageAccounts";
import { useTables } from "../../hooks/useTables";
import V2Stopwatch from "../../components/pool/V2Stopwatch";

const V2Pool = () => {
    const user: User = useOutletContext();
    const [showModal, setShowModal] = useState(false);
    const { tables, isLoading } = useTables();


    // const addSubmitHandler = async (e: HTMLFormElement) => {
    //     e.preventDefault();
    //     try {
    //         setIsLoading(true);
    //         const res = await addTable({ name: e.target.name.value });
    //
    //         if (res.error) {
    //             throw res.error;
    //         }
    //         getTables();
    //         toast.success("Added table successfully!");
    //     } catch (error: any) {
    //         toast.error(error?.message);
    //     } finally {
    //         setShowModal(false);
    //         setIsLoading(false);
    //     }
    // };

    return (
        <section className="mb-8">
            {isAdmin(user) && (
                <button
                    onClick={() => setShowModal(true)}
                    className="m-4 bg-success text-white dark:text-neutral-900 px-4 py-2 rounded-lg font-semibold"
                >
                    Add table
                </button>
            )}
            <div className="gridbox mt-4 sm:m-4">
                {tables.map((e: Table) => {
                    return (
                        <V2Stopwatch
                            key={e?.id}
                            table={e}
                            allTables={tables}
                        />
                    );
                })}
            </div>
            {showModal && (
                <AddTableModal
                    title="Add Table"
                    closeModal={() => setShowModal(false)}
                    submitHandler={() => { return null }}
                    isLoading={isLoading}
                >
                    <div>
                        <label htmlFor="name" className="label-text dark:text-white">
                            Name
                        </label>
                        <input
                            className="py-2 mb-4 rounded-lg bg-neutral-100 focus:ring-2 ring-success outline-none w-full px-4 dark:bg-neutral-800"
                            id="name"
                        />
                    </div>
                </AddTableModal>
            )}
        </section>
    );
};

export default V2Pool;
